import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/embr/assets/images/embrsays1.png'


const _hoisted_1 = { class: "-mx-4 p-4 items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: "",
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_BalBtn, {
          class: "mt-8",
          label: "Compose my pool",
          block: "",
          onClick: _withModifiers(_ctx.create, ["prevent"])
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}